import {
  PointsByType,
  PointType,
  StorePoint,
  StorePointFeature
} from '../types';

export const getPointsByTypes = (
  points: StorePoint[],
  pointTypes: PointType[]
): PointsByType[] => {
  return pointTypes.map((city) => {
    return {
      city,
      points: points
        .filter((point) => point.city === city)
        .map((point) => ({
          type: 'Feature',
          id: point.nom_code || '',
          geometry: {
            type: 'Point',
            coordinates: [+(point.longitude || ''), +(point.latitude || '')]
          },
          properties: {
            title: point.name,
            address: point.address,
            pointType: point.point_type,
            work_time: point.work_time,
            phone: point.phone
          }
        }))
    };
  });
};

export const getStorePoints = (points: StorePoint[]): StorePointFeature[] => {
  if (!points) {
    return [];
  }

  return points.map((point) => {
    const coordinates: [number, number] = [
      +(point.longitude || ''),
      +(point.latitude || '')
    ];

    return {
      type: 'Feature' as const,
      id: point.nom_code || '',
      geometry: {
        type: 'Point' as const,
        coordinates
      },
      properties: {
        title: point.name,
        address: point.address,
        pointType: point.point_type,
        work_time: point.work_time,
        phone: point.phone,
        in_stock: point.in_stock
      }
    };
  });
};
